import { Component } from "@angular/core";
import { Device } from "@nms-ng2/app/modules/device/device-backup/device-backup.models";
import { SimpleModalComponent } from "ngx-simple-modal";

/**
 * Modelo de dados da modal.
 */
interface Data {
    devices: Device[];
}

/**
 * Modal de confirmação dos ENDs para criação de links.
 */
@Component({
    selector: "confirm-add-link-modal",
    templateUrl: "./confirm-add-link-modal.component.html",
    styleUrls: ["./confirm-add-link-modal.component.scss"]
})
export class ConfirmAddLinkModalComponent extends SimpleModalComponent<Data, any> implements Data {

    devices: Device[] = []

    constructor() {
        super();
    }

    /**
     * Inverte a ordem dos equipamentos selecionados
     */
    invert() {
        this.devices.reverse();
    }

    /**
     * Confirma a alteração e insere a lista de devices no result para ser utilizada
     * no callback da chamada da modal.
     */
    confirm() {
        this.result = this.devices;
        this.close();
    }
}
